import React from 'react';
import { NavigationPath, AuthenticationState } from './constants';
import { HeaderType } from '../app/components/header/headerType';
import Home from '../portal/screens/home/Home';
import KitReturn from '../portal/screens/kit-return/KitReturn';
import TempusPro from '../portal/screens/tempus-pro/TempusPro';
import Logout from '../portal/screens/logout/Logout';
import TermsOfUseV2 from '../portal/screens/terms-of-use/TermsOfUse';
import Report from '../portal/screens/report/Report';
import Documents from '../portal/screens/documents/Documents';
import DocumentDetail from '../portal/screens/documents/DocumentDetail';
import ReviewPatientInfo from '../portal/screens/patient-info/ReviewPatientInfo';
import OnboardingManager from '../portal/onboarding/OnboardingManager';
import ForgotPassword from '../portal/screens/forgot-password/ForgotPassword';
import Landing from '../portal/screens/landing/Landing';

export type NavigationRoute = {
  component: React.ComponentType;
  header?: HeaderType;
  path: NavigationPath;
  authState: AuthenticationState;
};

export type AppNavigationType = {
  [key in AuthenticationState]: NavigationRoute[];
};

const AppNavigationRoutes: AppNavigationType = {
  [AuthenticationState.AUTH0_AUTHENTICATED]: [
    {
      component: ReviewPatientInfo,
      path: NavigationPath.REVIEW_PATIENT_INFO,
      authState: AuthenticationState.AUTH0_AUTHENTICATED,
    },
    {
      component: TermsOfUseV2,
      path: NavigationPath.TERMS_OF_USE,
      authState: AuthenticationState.AUTH0_AUTHENTICATED,
    },
    {
      component: KitReturn,
      path: NavigationPath.KIT_RETURN,
      authState: AuthenticationState.AUTH0_AUTHENTICATED,
    },
    {
      component: Home,
      path: NavigationPath.HOME,
      authState: AuthenticationState.AUTH0_AUTHENTICATED,
    },
    {
      component: TempusPro,
      path: NavigationPath.TEMPUS_PRO,
      authState: AuthenticationState.AUTH0_AUTHENTICATED,
    },
    {
      component: Report,
      path: NavigationPath.REPORT,
      authState: AuthenticationState.AUTH0_AUTHENTICATED,
    },
    {
      component: DocumentDetail,
      path: NavigationPath.DOCUMENT_DETAIL,
      authState: AuthenticationState.AUTH0_AUTHENTICATED,
    },
    {
      component: Documents,
      path: NavigationPath.DOCUMENTS,
      authState: AuthenticationState.AUTH0_AUTHENTICATED,
    },
    {
      component: Logout,
      path: NavigationPath.LOGOUT,
      authState: AuthenticationState.AUTH0_AUTHENTICATED,
    },
    {
      component: OnboardingManager,
      path: NavigationPath.ONBOARDING,
      authState: AuthenticationState.AUTH0_AUTHENTICATED,
    },
  ],
  [AuthenticationState.AUTH0_UNAUTHENTICATED]: [
    {
      component: ForgotPassword,
      path: NavigationPath.FORGOT_PASSWORD,
      authState: AuthenticationState.AUTH0_UNAUTHENTICATED,
    },
    {
      component: Landing,
      path: NavigationPath.LANDING,
      authState: AuthenticationState.AUTH0_UNAUTHENTICATED,
    },
  ],
};

export { AppNavigationRoutes, AuthenticationState, NavigationPath };
